export const API_PATH_apiAuthCurrentUserInfoGet = '/services/authentication/apiAuthCurrentUserInfoGet';
